import type { CustomerRequirement } from "../CustomerRequirement.js";

export function isSameCustomerRequirement(
	first: CustomerRequirement | undefined,
	second: CustomerRequirement | undefined,
): boolean {
	return first?.name === second?.name && first?.price === second?.price;
}
